"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "OverrideModal", {
  enumerable: true,
  get: function get() {
    return _OverrideModal.OverrideModal;
  }
});
var _OverrideModal = require("./OverrideModal");